module.exports = __webpack_public_path__ + "static/media/boxStep9.0038573b.png";